import React from "react";
import NavbarAdmin from "../commons/NavbarAdmin";
import NavUp from "../commons/NavUp";
import firebaseManager from "../model/Firebase/FirebaseManager";
import DentsAvailable from "./Component/DentsAvailable";

class Admin extends React.Component {
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        ele.classList.add("available");
        setTimeout(() => {
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  showAllDentPriceless = () => {
    firebaseManager.showDentPriceless();
  };

  render() {
    return (
      <React.Fragment>
        <NavUp />
        <div className="mb-5 pb-5">
        <DentsAvailable />
        </div>
        <NavbarAdmin />
      </React.Fragment>
    );
  }
}

export default Admin;
